import styled from 'styled-components';
import { tokens } from '../../public/tokens';
import { buttonBase, neutralPressStates } from './buttonBase';
import { MOBILE_MEDIA_QUERY } from './breakpoints';

const { colors } = tokens;

const ACTIVE_BORDER_COLOR = 'rgba(59, 180, 194, 0.502)';
const ACTIVE_BACKGROUND_COLOR = 'rgba(59, 180, 194, 0.05)';

/**
 * Tab-style button for switching between views in a section, where only one tab
 * is active at a time. Font Awesome icons are auto-styled via the nested `i`.
 * @param {boolean} [$active] Whether this is the selected tab
 * @param {boolean} [$fullWidth] Stretches to fill its container
 */
export const TabButton = styled.button(({ $fullWidth, $active }) => ({
    ...buttonBase,
    ...neutralPressStates,
    justifyContent: 'flex-start',
    minHeight: '50px',
    width: $fullWidth ? '100%' : 'auto',
    padding: '10px 24px',
    marginBottom: '10px',
    borderColor: $active ? ACTIVE_BORDER_COLOR : colors.surfaces['border-divider'],
    backgroundColor: $active ? ACTIVE_BACKGROUND_COLOR : colors.neutral.white,
    color: $active ? colors.ui.foreground : colors.text.primary,

    [MOBILE_MEDIA_QUERY]: {
        ...buttonBase[MOBILE_MEDIA_QUERY],
        padding: '10px 18px',
    },
}));
